module.exports = __webpack_public_path__ + "img/video_poster_old.e87182ca.png";